import api from "./index"

export default {
  getPermissions: (userId) => {
    return api.get(`security/permissions/${userId}`)
  }
}
